import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const POINTS = ['On-time arrivals and clear communication', 'Upfront pricing with no surprises', 'Clean, careful work in your home', 'Locally owned and operated in Arizona'];
export function About() {
  return <section id="about" className="w-full bg-white" data-id="element-11" data-mp="2ys5bdv01i7ni">
      <div className="mx-auto grid max-w-6xl gap-12 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:items-center" data-id="element-12" data-mp="2ysy966h0tmti">
        <div className="order-2 overflow-hidden rounded-3xl border border-slate-200 shadow-sm lg:order-1" data-id="element-13" data-mp="33qqcdwn48vd0">
          <img src="https://cdn.magicpatterns.com/uploads/2Zri6R64scGbzTz76cKRjV/plumber-about.jpg" alt="Plumber inspecting the pipes beneath a kitchen sink" className="h-full w-full object-cover" data-id="element-14" data-mp="38oi4aqnrghh7" />
        </div>

        <div className="order-1 lg:order-2" data-id="element-15" data-mp="3miitotstos4w">
          <span className="text-sm font-semibold uppercase tracking-wide text-sky-600" data-id="element-16" data-mp="3mjkf9s7gsx0v">
            About us
          </span>
          <h2 className="mt-2 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-17" data-mp="2lr7ii6i4g62y">
            Plumbing done with care and precision
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-18" data-mp="2gqt7qgp4yi18">
            Flow State Plumbers is a local, family-minded team serving Phoenix, Casa Grande, and
            Tucson. We show up on time, treat your home with respect, and stand behind every job.
          </p>

          <ul className="mt-6 space-y-3" data-id="element-19" data-mp="34gni8rlzfuib">
            {POINTS.map(point => <li key={point} className="flex items-start gap-3" data-id="element-20" data-mp="30fljebvz9kgv">
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-sky-600" data-id="element-21" data-mp="30ihg5ww3a33q" />
                <span className="text-slate-700" data-id="element-22" data-mp="2vnkbf25uefwn">{point}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}